<template>
  <div>
    <v-sheet class="py-3 py-md-8" color="primary">
      <TitleWidget>
        {{ title }}
      </TitleWidget>
    </v-sheet>

    <v-container class="pt-6 pb-10 pb-md-13 pb-lg-16">
      <ProductFilter />

      <div class="mt-6">
        <LoadingWidget v-if="loading" />

        <template v-else>
          <template v-if="items.length">
            <div class="mt-6 mt-md-8 items">
              <ProductCard
                v-for="(item, keyItems) in items"
                :key="keyItems"
                v-bind="item"
              ></ProductCard>
            </div>

            <v-pagination
              class="mt-6"
              v-if="pagesLength > 1"
              v-model="page"
              :length="pagesLength"
              :total-visible="6"
              flat
            ></v-pagination>
          </template>

          <v-alert v-else type="info">
            {{ noContentText }}
          </v-alert>
        </template>
      </div>
    </v-container>
  </div>
</template>

<script>
import TitleWidget from "../components/widgets/TitleWidget.vue";
import LoadingWidget from "../components/widgets/LoadingWidget.vue";
import ProductFilter from "../components/forms/ProductFilter.vue";
import ProductCard from "../components/cards/ProductCard.vue";
import { formatToURL } from "../utils/formatToURL";
import { productFilter } from "../utils/productFilter";

const _config = {
  mod: "products",
};

const _pagination = {
  itemsPerPage: 24,
  returnTotalItems: 1,
};

const _data = {
  loading: true,
  totalItems: 0,
  noContentText: "Nenhum produto adicionado até o momento",
};

export default {
  data: () => ({
    ..._data,
  }),
  computed: {
    title() {
      switch (this.categoryId) {
        case 1:
          return "Peças";
        case 2:
          return "Ferramentas";
        default:
          return "Todos os Produtos";
      }
    },
    items() {
      return this.$rest(_config.mod).list.map(
        ({ id, img, title, brand, category }) => ({
          img: img ? this.files + img : "",
          title,
          brand,
          to: `/${formatToURL(category.title)}/${formatToURL(
            `${title}-${id}`
          )}`,
        })
      );
    },
    pagesLength() {
      return Math.ceil(this.totalItems / _pagination.itemsPerPage);
    },
    page: {
      get() {
        const p = this.query.p;
        return p ? parseInt(p) : 1;
      },
      set(v) {
        const query = { ...this.query };
        if (v) query.p = v;
        else delete query.p;

        this.$router.push({ path: `${this.$route.path}`, query });
      },
    },
  },
  methods: {
    getList() {
      this.loading = true;

      const params = {
        returnTotalItems: _pagination.returnTotalItems,
        itemsPerPage: _pagination.itemsPerPage,
      };

      if (this.page) params.page = this.page;
      if (this.query.c) params.subcategory = this.query.c;
      if (this.search) params.search = this.search;
      if (this.categoryId) params.category = this.categoryId;

      this.$rest(_config.mod)
        .get({
          params,
          keepCache: true,
          save: (state, data) => {
            if (_pagination.returnTotalItems) {
              this.totalItems = data.totalItems;
              state.list = data.list;
            } else state.list = data;
          },
        })
        .finally(() => (this.loading = false));
    },
  },
  watch: {
    $route() {
      this.getList();
    },
  },
  created() {
    this.getList();
  },
  components: {
    TitleWidget,
    LoadingWidget,
    ProductFilter,
    ProductCard,
  },
  mixins: [productFilter],
};
</script>

<style lang="scss" scoped>
.items {
  display: grid;
  gap: 30px;
  grid-template-columns: repeat(4, 1fr);

  @media screen and (max-width: 1279.9px) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media screen and (max-width: 959.9px) {
    gap: 12px;
    grid-template-columns: repeat(2, 1fr);
  }
}
</style>
